import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { AccountSelectors, ModulesSelectors } from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'serviceos-web-referral-link',
    templateUrl: './referral-link.component.html',
    styleUrls: ['./referral-link.component.scss'],
})
export class ReferralLinkComponent implements OnInit, OnDestroy {
    @Select(AccountSelectors.referralCode)
    referralCode!: Observable<string>;

    @Select(ModulesSelectors.getModuleConfigText('account'))
    moduleAccountTexts$!: Observable<any>;

    @Input() referralDomain: string = window.location.origin;

    public referralLink: string | '' = '';
    public subscribe: Subscription | null = null;

    referralCopySuccess = false;

    constructor() {}

    ngOnInit(): void {
        this.subscribe = this.referralCode.subscribe((referralCode) => {
            if (referralCode) {
                this.referralLink =
                    this.referralDomain + '/referral/' + referralCode;
            } else {
                this.referralLink = '';
            }
        });
    }

    public copyText(data: string): void {
        if (this.referralCopySuccess) {
            return;
        }

        this.referralCopySuccess = true;

        setTimeout(() => {
            this.referralCopySuccess = false;
        }, 2000);

        const input = document.createElement('textarea');
        input.value = data;
        input.setAttribute('readonly', '');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);

        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            const oldContentEditable = input.contentEditable,
                oldReadOnly = input.readOnly,
                range = document.createRange();

            input.contentEditable = 'true';
            input.readOnly = false;
            range.selectNodeContents(input);

            const s: any = window.getSelection();
            s.removeAllRanges();
            s.addRange(range);

            input.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

            input.contentEditable = oldContentEditable;
            input.readOnly = oldReadOnly;

            document.execCommand('copy');
        } else if (input.select) {
            input.select();

            try {
                document.execCommand('copy');
                input.value = data;
                input.select();
            } catch (err) {
                alert('please press Ctrl/Cmd+C to copy');
            }
        }

        document.body.removeChild(input);
    }

    ngOnDestroy(): void {
        this.subscribe?.unsubscribe();
    }
}
